module.exports = __webpack_public_path__ + "008a9023f797caa472e85c05ae2f9b29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-13.jpg
// module id = 1153
// module chunks = 0